module.exports = __webpack_public_path__ + "img/argendata2.cf840dc0.jpg";